document.addEventListener("DOMContentLoaded", function() {
  if(document.querySelector('.language-dropdown button')) {
    var dropdownButton = document.querySelector('.language-dropdown button');

    dropdownButton.addEventListener('click', function() {
      var dropdownContent = this.nextElementSibling;
      var isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Toggle aria-expanded attribute
      this.setAttribute('aria-expanded', !isExpanded);

      // Toggle visibility of the dropdown content
      dropdownContent.style.display = isExpanded ? 'none' : 'block';
    });
  }
});
